/**
 * TimePicker.jsx
 *
 * @Author: apple
 * @Date: 2018/3/1 01:02
 */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Tooltip from '../tooltip';
import WatchLater from '../icons/internals/WatchLater';
import Input from '../input';
import TimeOptions from './TimePanel';

/**
 * TimePicker
 * */
class TimePicker extends React.PureComponent {
  static propTypes = {
    /**
     * 更新时间回调函数
     * @params time: 所选时间
     * @return
     * */
    onChange: PropTypes.func,
    /**
     * 类名前缀
     * */
    prefixCls: PropTypes.string,
    /**
     * 禁用小时
     * @return true为禁用 false为不禁用
     * */
    disabledHours: PropTypes.func,
    /**
     * 禁用分钟
     * @params selectHour:当前所选小时
     * @return true为禁用 false为不禁用
     * */
    disabledMinutes: PropTypes.func,
    /**
     * 禁用秒
     * @params selectHour:当前所选小时, selectMinute:当前所选分钟
     * @return true为禁用 false为不禁用
     * */
    disabledSeconds: PropTypes.func,
    /**
     * 后缀
     * */
    suffix: PropTypes.node,
    /**
     *  scrollContainer Tooltip兼容自定义可滚动容器
     */
    scrollContainer: PropTypes.node,
  };

  static defaultProps = {
    prefixCls: 'ne-time-picker',
    defaultIsOpen: false,
    format: 'HH:mm:ss',
    suffix: <WatchLater />,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.defaultValue !== state.prevDefaultValue) {
      return {
        value: props.defaultValue,
        prevDefaultValue: props.defaultValue,
      };
    }
    return null;
  }

  constructor(props, context) {
    super(props, context);
    const { defaultValue, defaultIsOpen, format } = props;

    this.state = {
      value: defaultValue ? moment(defaultValue, format) : undefined,
      prevDefaultValue: defaultValue,
      isOpen: defaultIsOpen,
    };
  }

  handleInput = e => {
    const { value } = e.target;
    const { onChange, format } = this.props;
    const valueMoment = moment(value, format);
    if (valueMoment.isValid()) {
      this.setState({
        value: valueMoment,
      });
      onChange && onChange(value);
    }
  };

  handleDialog = isOpen => {
    this.setState({
      isOpen,
    });
  };

  onChange = value => {
    const { onChange } = this.props;
    this.setState({
      value,
    });
    onChange && onChange(value);
  };

  render() {
    const {
      clearable,
      disabled,
      inputClass,
      prefix,
      size,
      prefixCls,
      readOnly,
      disabledHours,
      disabledMinutes,
      disabledSeconds,
      format,
      suffix,
      inputProps,
      scrollContainer,
    } = this.props;
    const { value, isOpen } = this.state;

    return (
      <Tooltip
        trigger="click"
        className={`${prefixCls}-tooltip`}
        position="bottomLeft"
        onOpen={() => this.handleDialog(true)}
        onClose={() => this.handleDialog(false)}
        scrollContainer={scrollContainer}
        content={
          <Input
            defaultValue={value ? value.format(format) : ''}
            disabled={disabled}
            readOnly
            className={inputClass}
            prefix={prefix}
            size={size}
            clearable={clearable}
            suffix={suffix}
            onBlur={this.handleInput}
            {...inputProps}
          />
        }>
        <TimeOptions
          value={value}
          isOpen={isOpen}
          onValueChange={this.onChange}
          disabledHours={disabledHours}
          disabledMinutes={disabledMinutes}
          disabledSeconds={disabledSeconds}
        />
      </Tooltip>
    );
  }
}

export default TimePicker;



// WEBPACK FOOTER //
// ./src/timePicker/TimePicker.jsx